exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "div {\r\n    padding: 0;\r\n    text-align: center;\r\n    max-width: 1000px;\r\n}\r\n\r\n.separator {\r\n    width: 1000px;\r\n    height: 1px;\r\n    background-color:#c0c0c0;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/header/header.component.css
// module id = 740
// module chunks = 1